module.exports = __webpack_public_path__ + "img/aus-states-map.98a6b59e.png";